export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';
export const CLEAR_RECOMMENDATIONS = 'CLEAR_RECOMMENDATIONS';
export const CLEAR_RECOMMENDATIONS_INDICATION = 'CLEAR_RECOMMENDATIONS_INDICATION';
export const FETCH_RECOMMENDATIONS_INDICATION_ERROR = 'FETCH_RECOMMENDATIONS_INDICATION_ERROR';
export const FETCH_RECOMMENDATIONS_INDICATION_SUCCESS = 'FETCH_RECOMMENDATIONS_INDICATION_SUCCESS';
export const REQUEST_FETCH_RECOMMENDATIONS_INDICATION = 'REQUEST_FETCH_RECOMMENDATIONS_INDICATION';
